var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_121_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0805 5.5075C14.387 5.5075 13.3708 4.1775 13.3708 2.8475C13.3708 1.5175 14.387 0.1875 16.0805 0.1875C17.4354 0.1875 18.7902 1.5175 18.7902 2.8475C18.7902 4.51 17.4354 5.5075 16.0805 5.5075Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.93548 18.1425V13.155L11 5.83999H7.6129L5.24194 9.82999L2.87097 8.16749L6.25806 3.17999H12.3548C12.6935 4.84249 14.0484 6.50499 16.0806 6.50499H16.4194V10.1625H21.5V12.8225H16.4194H13.7097V11.16L11.6774 14.485L16.0806 17.4775V25.125H13.7097V18.8075L9.64516 16.48V18.1425V20.8025H6.93548H0.5V18.1425H6.93548Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_121_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24.9375,
    fill: "white",
    transform: "translate(0.5 0.1875)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.c587ec1749a5de3fc510dc95662cb99c.svg";
export { ForwardRef as ReactComponent };